import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

export const Disclaimer = () => {
  return (
    <div className="min-h-screen py-16">
      <div className="container-custom max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex items-center gap-3 mb-4">
            <AlertTriangle className="w-8 h-8 text-warning" />
            <h1 className="font-serif text-5xl font-bold text-foreground">
              Product Disclaimer
            </h1>
          </div>
          <p className="text-muted-foreground mb-8">Important information about our products</p>

          <div className="space-y-6">
            <Card className="border-warning">
              <CardContent className="p-6">
                <h2 className="font-serif text-2xl font-semibold mb-4">Medical Disclaimer</h2>
                <p className="text-muted-foreground leading-relaxed">
                  The products sold on this website are cosmetics and over-the-counter (OTC) pharmaceutical products. They are not intended to diagnose, treat, cure, or prevent any disease. Always consult with a qualified healthcare professional before using any new product, especially if you have pre-existing medical conditions or are pregnant or nursing.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <h2 className="font-serif text-2xl font-semibold mb-4">Prescription Products</h2>
                <p className="text-muted-foreground leading-relaxed">
                  We do not sell prescription medications. All pharmaceutical products available on our website are over-the-counter and do not require a prescription. Never use prescription medications without proper medical supervision.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <h2 className="font-serif text-2xl font-semibold mb-4">Allergies and Sensitivities</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Please carefully review the ingredient list for each product before purchase. If you have known allergies or sensitivities:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Check all ingredients before use</li>
                  <li>Perform a patch test before full application</li>
                  <li>Discontinue use if irritation occurs</li>
                  <li>Consult a healthcare professional if you have concerns</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <h2 className="font-serif text-2xl font-semibold mb-4">Product Use and Safety</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  For your safety:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Follow all usage instructions provided on product labels</li>
                  <li>Store products as directed</li>
                  <li>Keep all products out of reach of children</li>
                  <li>Check expiration dates before use</li>
                  <li>Do not use products if seals are broken or tampered with</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <h2 className="font-serif text-2xl font-semibold mb-4">Results May Vary</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Individual results may vary. Product effectiveness can depend on various factors including skin type, age, lifestyle, and consistent use. The results described in product descriptions or customer reviews may not be typical.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <h2 className="font-serif text-2xl font-semibold mb-4">Quality and Authenticity</h2>
                <p className="text-muted-foreground leading-relaxed">
                  All products sold on NaturalCare are sourced from authorized distributors and are guaranteed to be authentic. We stand behind the quality of our products.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-muted/30">
              <CardContent className="p-6">
                <h2 className="font-serif text-2xl font-semibold mb-4">Questions or Concerns?</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  If you have any questions about our products or need guidance on product selection, please contact our customer service team:
                </p>
                <div className="space-y-2">
                  <p>
                    <span className="font-medium">Email:</span>{' '}
                    <a href="mailto:support@naturalcare.com" className="text-primary hover:underline">
                      support@naturalcare.com
                    </a>
                  </p>
                  <p>
                    <span className="font-medium">Phone:</span>{' '}
                    <a href="tel:+15551234567" className="text-primary hover:underline">
                      +1 (555) 123-4567
                    </a>
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </motion.div>
      </div>
    </div>
  );
};